import { defineComponent as _defineComponent } from 'vue'
import WizardStep from '@/components/wizard/WizardStep.vue';
import { useI18n } from '@/composables/i18n';
import { StandardAlertEligibleDevice } from '@/models/standardAlert';
import { isEmpty } from '@/utils/misc';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'EquipmentSelectionWizardStep',
  props: {
    value: null,
    eligibleDevices: null,
    applyToAllEquipment: { type: Boolean },
    loading: { type: Boolean }
  },
  emits: ["input", "update:applyToAllEquipment"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', value: StandardAlertEligibleDevice[]): void;
  (e: 'update:applyToAllEquipment', value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: StandardAlertEligibleDevice[];
  eligibleDevices: StandardAlertEligibleDevice[];
  applyToAllEquipment: boolean;
  loading: boolean;
};





const { t } = useI18n();

const selectedDevices = computed<StandardAlertEligibleDevice[]>({
  get() {
    return props.value;
  },
  set(newValue) {
    emit('input', newValue);
  },
});

const allowNext = computed<boolean>(() => {
  if (isEmpty(props.eligibleDevices)) {
    return false;
  }

  return props.applyToAllEquipment || !isEmpty(selectedDevices.value);
});

return { __sfc: true,props, emit, t, selectedDevices, allowNext, WizardStep }
}

})